import { Heart } from 'lucide-react';
import { motion } from 'framer-motion';

export default function LoadingScreen() {
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-primary-50 to-accent/20 flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-center space-y-8"
      >
        <motion.div
          animate={{ scale: [1, 1.05, 1] }}
          transition={{ duration: 2, repeat: Infinity }}
          className="flex items-center justify-center gap-3"
        >
          <svg className="w-12 h-12" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
            <defs><linearGradient id="loadLogoBg" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#0D9488" /><stop offset="100%" stopColor="#0F766E" /></linearGradient></defs>
            <rect x="10" y="10" width="180" height="180" rx="36" ry="36" fill="url(#loadLogoBg)" />
            <rect x="80" y="45" width="40" height="110" rx="8" ry="8" fill="white" />
            <rect x="45" y="80" width="110" height="40" rx="8" ry="8" fill="white" />
            <polyline points="45,100 70,100 78,82 88,118 98,85 108,115 118,92 128,100 155,100" fill="none" stroke="#0D9488" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" opacity="0.6" />
          </svg>
          <Heart className="w-12 h-12 text-secondary" />
        </motion.div>

        <div>
          <h1 className="text-3xl font-bold text-text mb-2">Strix Healthcare</h1>
          <p className="text-text-secondary">Secure, Governed Patient Care</p>
        </div>

        <div className="flex gap-2 justify-center">
          {[0, 1, 2].map((i) => (
            <motion.div
              key={i}
              animate={{ height: [8, 32, 8] }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                delay: i * 0.2,
              }}
              className="w-2 bg-primary rounded-full"
            />
          ))}
        </div>

        <div className="space-y-2">
          <div className="h-2 bg-primary-100 rounded-full overflow-hidden">
            <motion.div
              animate={{ x: ['0%', '100%'] }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
              }}
              className="h-full w-1/3 bg-gradient-to-r from-primary to-accent rounded-full"
            />
          </div>
          <p className="text-xs text-text-tertiary">Loading...</p>
        </div>
      </motion.div>
    </div>
  );
}
